import type { FaireProductEntity } from "../../entity_types/product";

export const p_4qubbw3smy: FaireProductEntity = {
  token: "p_4qubbw3smy",
  type: "product",
  name: "Wax Bottles",
  brandToken: "b_mukk4ka83q",
  brandName: "The Penny Candy Store",
  imageUrl:
    "https://cdn.faire.com/fastly/758b0b46f7b1eedd78fc969d503f5536abcb5e47f48cf0f63bab00958d662fde.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c49cf78f8bc1c302e741f8faa125438ec3fcc34a2a94b31e00e58af51b913579.jpeg",
    "https://cdn.faire.com/fastly/e185ff7ac9b104d54f16b3b947be62fe3985e1cb0801ec63ae8bdbbfeb9617aa.jpeg",
    "https://cdn.faire.com/fastly/077c8eccbf7f5bcbf974a5825424b49a69315d4f1bd3e5de4a3e80578d7dae37.jpeg",
  ],
  priceDollars: 2.29,
  description:
    "Experience Wax Bottles, a nostalgic Candy from The Penny Candy Store. Made in the USA and using recyclable packaging, these candies balance tradition with sustainability with a 12-24 month shelf life.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:08.524Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
